<template>
  <v-app-bar
    app
    fixed
    clipped-left
    flat
    dark
    color="primary"
  >
    <v-app-bar-nav-icon
      @click.stop="$eventHub.$emit('toggleNavigationDrawer')"
      class="ml-3 mr-4"
    />

    <router-link to="/" style="text-decoration: none; color: inherit;" v-on:click.native="sendGaEvent">
      <v-toolbar-title class="pl-0">
        <AppIcon
          appName="my-ictplus"
          :transparent="false"
          size="40"
          class="mt-2"
        />
      </v-toolbar-title>
    </router-link>

    <router-link to="/" style="text-decoration: none; color: inherit;" v-on:click.native="sendGaEvent">
      <v-toolbar-title class="pl-0">
        <span
          class="ml-0 pl-4 mr-5 mb-4 hidden-sm-and-down"
          style="vertical-align: middle; line-height: 40px;">
          <span style="font-weight: bold;">{{title}}</span>
          <span class="beta">BETA</span>
        </span>
      </v-toolbar-title>
    </router-link>

    <v-spacer/>

    <div style="width: 500px;" class="mr-10">
      <SchoolAutocomplete/>
    </div>

    <div class="mr-2">
      <Profile
        :givenName="claims.givenName"
        :surname="claims.sn"
        :jobTitle="school.site_name"
        :updateProfile="false"
        :updateSecretQuestion="false"
        :changePassword="false"
        :portalSettings="false"
        :logout="true"
        :logoutHandler="samlSsoLogout"
      />
    </div>
  </v-app-bar>
</template>

<script>
  import {mapActions, mapGetters, mapState, mapMutations} from "vuex";
  import SchoolAutocomplete from "../components/SchoolAutocomplete";
  import {Profile, AppIcon} from '@nswdoe/doe-ui-core';

  export default {
    name: "AppBar",
    components: {
      // SchoolDetailsMenu,
      Profile,
      SchoolAutocomplete,
      AppIcon
    },
    props: {
      title: String
    },
    data() {
      return {};
    },
    methods: {
      ...mapActions(['fetchSchool', 'removeToken','clearAllFilters']),
      ...mapMutations(['toggleDrawer']),
      samlSsoLogout() {

        const schoolSiteCode = this.school.site_code? this.school.site_code : '*';
        this.$ga.event({
          eventCategory: 'App',
          eventAction: 'logout click',
          eventLabel: `sitecode:${schoolSiteCode}`
        });

        let ssoLogoutUrl = `https://ssoaddonsext.test.det.nsw.edu.au/ssoaddon/logout`;
        if (location.hostname.match('test.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.test.det.nsw.edu.au/ssoaddon/logout`;
        } else if (location.hostname.match('pre.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.pre.det.nsw.edu.au/ssoaddon/logout`;
          console.log(ssoLogoutUrl);
        } else if (location.hostname.match('ictplus.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.det.nsw.edu.au/ssoaddon/logout`;
        }
        console.log(ssoLogoutUrl);
        //sessionStorage.removeItem('ictp-token');
        //sessionStorage.removeItem('ictp-splash-page-status');
        this.clearAllFilters();
        sessionStorage.clear();
        this.removeToken(this.$store.state);
        window.location = ssoLogoutUrl;
      },
      sendGaEvent () {
        const schoolSiteCode = this.school.site_code? this.school.site_code : '*';
        this.$ga.event({
          eventCategory: 'App',
          eventAction: 'logo click',
          eventLabel: `sitecode:${schoolSiteCode}`
        });
      }
    },
    mounted() {
      if (this.claims && this.claims.sitecodes) {
        const siteCodes = this.claims.sitecodes;
        if (Array.isArray(siteCodes) && siteCodes.length > 0) {
          if (siteCodes.indexOf('*') === -1) {
            const defaultSiteCode = siteCodes[0];
            this.fetchSchool(defaultSiteCode);
          }
        }
      }
    },
    computed: {
      ...mapState({
        school: s => s.school.selected
      }),
      ...mapGetters(['claims', 'hasAnyRoleIn']),
    },
  }
</script>

<style scoped>
  .beta {
    height: 21px;
    width: 94px;
    color: #FFFFFF;
    font-family: Arial;
    font-size: 14px;
    line-height: 21px;
    margin-left: 10px;
  }

</style>
